import castArray from 'lodash/castArray';
import compact from 'lodash/compact';
import forEach from 'lodash/forEach';
import { HttpError } from 'react-admin';

const processValidationError = (response) => {
    return response.json().then((json) => {
        const message = formatValidationError(json);
        const error = new HttpError(message, response.status, json);

        // React Admin 5 looks for an 'errors' property to display field-level validation errors.
        // Transform { field: [msg1, msg2] } to { field: 'msg1, msg2' }
        const fieldErrors = {};
        Object.keys(json).forEach((key) => {
            fieldErrors[key] = formatFieldErrors(json[key]);
        });

        error.errors = fieldErrors;
        throw error;
    });
};

const formatValidationError = (json) => {
    let errors = [];
    const { base, ...fields } = json;

    errors.push(formatFieldErrors(base));

    if (fields) {
        forEach(fields, (fieldErrors, field) => {
            const errorMsg = formatFieldErrors(fieldErrors);
            if (errorMsg) {
                errors.push(`${field}: ${errorMsg}`);
            }
        });
    }

    errors = compact(errors);
    return errors.length > 0 ? errors.join('; ') : 'Validation error';
};

const formatFieldErrors = (errors) => {
    if (!errors) return null;

    errors = castArray(errors);
    if (errors.length === 0) return null;

    return errors.join(', ');
};

export {
    processValidationError,
    formatValidationError,
};
